import { ChevronFirst, ChevronLast, ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from '@/components/lemmala-design-system/button/button'
import { Select } from '@/components/lemmala-design-system/select/select'

import { CalendarHeaderProps } from './types'
import { getYearOptions } from './utils'

export const CalendarHeader = ({
  month,
  onPreviousYear,
  onPreviousMonth,
  onNextMonth,
  onNextYear,
  onYearChange,
  showPrevNav = true,
  showNextNav = true,
}: CalendarHeaderProps) => {
  const monthLabel = month.toLocaleString('default', { month: 'long' })

  return (
    <div className='flex items-center justify-between border-b border-main-border-hint bg-main-background-card p-1'>
      <span className='flex items-center gap-1'>
        {showPrevNav && (
          <Button
            aria-label='Previous year'
            size={'icon'}
            variant={'ghost-secondary'}
            onClick={onPreviousYear}
          >
            <ChevronFirst size={16} />
          </Button>
        )}
        {showPrevNav && (
          <Button
            aria-label='Previous month'
            size={'icon'}
            variant={'ghost-secondary'}
            onClick={onPreviousMonth}
          >
            <ChevronLeft size={16} />
          </Button>
        )}
      </span>
      <span className='flex select-none items-center gap-1 text-main-foreground-primary text-label-default'>
        <span>{monthLabel}</span>
        <Select<number>
          value={month.getFullYear()}
          onChange={(year) => onYearChange?.(year)}
          options={getYearOptions()}
          aria-label='Select year'
          variant='borderless'
          popupMatchSelectWidth={false}
          className='h-6 w-auto min-w-0 text-main-foreground-primary text-label-default'
        />
      </span>
      <span className='flex items-center gap-1'>
        {showNextNav && (
          <Button
            aria-label='Next month'
            size={'icon'}
            variant={'ghost-secondary'}
            onClick={onNextMonth}
          >
            <ChevronRight size={16} />
          </Button>
        )}
        {showNextNav && (
          <Button
            aria-label='Next year'
            size={'icon'}
            variant={'ghost-secondary'}
            onClick={onNextYear}
          >
            <ChevronLast size={16} />
          </Button>
        )}
      </span>
    </div>
  )
}
